import React from 'react'

export default class PrintCollaborationCount extends React.Component {

  render() {
    const {option, collaborationresponse} = this.props
    const questionHasCountedCollaboration = collaborationresponse ? (Object.keys(collaborationresponse).length > 0 ?
      ('id' in option) : false) : false
    const isExplanation = 'optionText' in option ? (option.optionText === undefined || option.optionText === '') : false
    const uniq = a => [...new Set(a)] //removes duplicate entries on a array
    const collaboratorIds = questionHasCountedCollaboration ?
      uniq(Object.keys(collaborationresponse).map(optionIdResponse => {
        return collaborationresponse[optionIdResponse].map(p => p.id)
      }).reduce((a, b) => [...a, ...b], [])) : []

    return questionHasCountedCollaboration && <div className={"question-collaboration"} key={option.id}>
      {!isExplanation &&
        <span>{(option.total ? option.total : 0) + ' van ' + collaboratorIds.length + ' (medewerkers kozen dit antwoord)'}</span>}
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/PrintCount.js